import { clients } from '../clients/grpcClients';
import { useLocalStorage } from '../stores/localStorage';
import {
  GetCategoriesRequest,
  GetCategoriesResponse,
  GetFoundryItemsRequest,
  GetFoundryItemsResponse,
  GetFoundryItemsByCategoryPathRequest,
  GetFoundryItemsByCategoryPathResponse,
  GetFoundryItemByIdRequest,
  GetFoundryItemByIdResponse,
} from './protosCompiled/buildFoundry/buildFoundry_pb';

export class BuildFoundryService {
  private static getMetadata() {
    const sessionToken = useLocalStorage.getState().sessionToken;
    if (!sessionToken) {
      console.error('Session token is missing!');
    }
    return {
      sessionToken,
    };
  }

  public static getCategories = (): Promise<GetCategoriesResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new GetCategoriesRequest();
      request.setSessiontoken(this.getMetadata().sessionToken);

      clients.buildFoundryServiceClient.getCategories(
        request,
        {},
        (err, response: GetCategoriesResponse) => {
          if (err) {
            console.error('Error fetching categories:', err);
            reject(err);
            return;
          }
          resolve(response.toObject());
        }
      );
    });
  };

  public static getFoundryItems = (
    categoryId?: string,
    page?: number,
    perPage?: number,
    search?: string
  ): Promise<GetFoundryItemsResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new GetFoundryItemsRequest();
      request.setSessiontoken(this.getMetadata().sessionToken);

      if (categoryId) {
        request.setCategoryId(categoryId);
      }
      if (page !== undefined) {
        request.setPage(page);
      }
      if (perPage !== undefined) {
        request.setPerPage(perPage);
      }
      if (search) {
        request.setSearch(search);
      }

      clients.buildFoundryServiceClient.getFoundryItems(
        request,
        {},
        (err, response: GetFoundryItemsResponse) => {
          if (err) {
            console.error('Error fetching foundry items:', err);
            reject(err);
            return;
          }
          resolve(response.toObject());
          console.log('Foundry items:', response.toObject());
        }
      );
    });
  };

  public static getFoundryItemsByCategoryPath = (
    categoryPath: string
  ): Promise<GetFoundryItemsByCategoryPathResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new GetFoundryItemsByCategoryPathRequest();
      request.setSessiontoken(this.getMetadata().sessionToken);
      request.setCategorypath(categoryPath);

      clients.buildFoundryServiceClient.getFoundryItemsByCategoryPath(
        request,
        {},
        (err, response: GetFoundryItemsByCategoryPathResponse) => {
          if (err) {
            console.error('Error fetching foundry items by category path:', err);
            reject(err);
            return;
          }
          resolve(response.toObject());
          console.log('Foundry items by category path:', response.toObject());
        }
      );
    });
  };

  public static getFoundryItemById = (
    itemId: string
  ): Promise<GetFoundryItemByIdResponse.AsObject> => {
    return new Promise((resolve, reject) => {
      const request = new GetFoundryItemByIdRequest();
      request.setSessiontoken(this.getMetadata().sessionToken);
      request.setId(itemId);

      clients.buildFoundryServiceClient.getFoundryItemById(
        request,
        {},
        (err, response: GetFoundryItemByIdResponse) => {
          if (err) {
            console.error('Error fetching foundry item by id:', err);
            reject(err);
            return;
          }
          resolve(response.toObject());
          console.log('Foundry item by id:', response.toObject());
        }
      );
    });
  };
}
